export default "__VITE_ASSET__1f8ca570__"